export const content = {
  ui: {
    next: 'Weiter',
    prev: 'Zurück',
  },
}
